import React from 'react';
import styled from 'styled-components';
import { Users } from 'lucide-react';

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--hover-background);
  border-radius: 16px;
  font-size: 13px;
  color: var(--text-secondary);
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: var(--text-tertiary);
`;

// כל הצוות רואה את כל הלידים (הנראות נפתחה בבקנד) — הצ'יפ אחיד.
const RoleIndicatorChip: React.FC = () => {
  return (
    <Chip>
      <IconWrapper>
        <Users size={14} />
      </IconWrapper>
      כל הלידים במערכת
    </Chip>
  );
};

export default RoleIndicatorChip;
